import * as React from 'react';
import { IconDeprecated as Icon } from '../../IconDeprecated.js';
import '../../../VisualAssets/IconV3/index.js';
import { useIconV2ToV3Adapter } from './hooks/useIconV2ToV3Adapter.js';
import { IconV3 as IconV3Memoized } from '../../../VisualAssets/IconV3/Icon.js';

var IconV2ToV3Adapter = function IconV2ToV3Adapter(props) {
  var content = useIconV2ToV3Adapter(props);
  if (content.iconV2Props) {
    return /*#__PURE__*/React.createElement(Icon, content.iconV2Props, props.children);
  }
  if (content.iconV3Props) {
    return /*#__PURE__*/React.createElement(IconV3Memoized, content.iconV3Props);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
IconV2ToV3Adapter.defaultProps = Icon.defaultProps;

export { IconV2ToV3Adapter };
//# sourceMappingURL=IconV2ToV3Adapter.js.map
